export const DURATIONS = ["Up to 30 seconds", "30–60 seconds", "1–3 minutes", "3–10 minutes", "Over 10 minutes", "Mixed / not sure"];
export const PLATFORMS = ["Instagram Reels", "YouTube Shorts", "YouTube", "LinkedIn", "Facebook", "Website / Ads", "Multiple platforms"];
export const RATIOS = ["9:16 (vertical)", "1:1 (square)", "4:5 (portrait)", "16:9 (horizontal)", "Multiple ratios"];
export const BUDGETS = ["", "Under ₹10,000", "₹10,000 – ₹25,000", "₹25,000 – ₹75,000", "₹75,000+", "Not sure yet"];

export const EMPTY = {
  name: "", email: "", company: "", service_id: "", video_count: 1, duration: "", platform: "", aspect_ratio: "",
  delivery_date: "", budget_range: "", brief: "", references: "", footage_link: "", additional: "", consent: false, website: "",
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const URL_RE = /^https?:\/\/\S+\.\S+/i;

export function validateStep(step, f) {
  const e = {};
  if (step === 0) {
    if (f.name.trim().length < 2) e.name = "Please enter your name.";
    if (!EMAIL_RE.test(f.email.trim())) e.email = "Enter a valid work email.";
  }
  if (step === 1) {
    if (!f.service_id) e.service_id = "Choose a service.";
    const n = Number(f.video_count);
    if (!Number.isInteger(n) || n < 1 || n > 500) e.video_count = "Enter between 1 and 500 videos.";
    if (!f.duration) e.duration = "Choose an approximate duration.";
    if (!f.platform) e.platform = "Choose a platform.";
    if (!f.aspect_ratio) e.aspect_ratio = "Choose an aspect ratio.";
    if (f.delivery_date && f.delivery_date < new Date().toISOString().slice(0, 10)) e.delivery_date = "Date can't be in the past.";
  }
  if (step === 2) {
    if (f.brief.trim().length < 20) e.brief = "Tell us a little more (at least 20 characters).";
    if (f.footage_link && !URL_RE.test(f.footage_link.trim())) e.footage_link = "Use a full link starting with https://";
    if (!f.consent) e.consent = "Please agree so we can process your enquiry.";
  }
  return e;
}
